import { render, staticRenderFns } from "./ChatSuggest.vue?vue&type=template&id=28796e88&scoped=true&"
import script from "./ChatSuggest.vue?vue&type=script&lang=js&"
export * from "./ChatSuggest.vue?vue&type=script&lang=js&"
import style0 from "./ChatSuggest.vue?vue&type=style&index=0&id=28796e88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28796e88",
  null
  
)

export default component.exports